<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body">
                        <div class="row d-flex align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0">
                                    <i class="bx bx-flag me-1 text-primary"></i>Milestones
                                </h5>
                            </div>
                            <div class="col">
                                <div ngbDropdown autoClose="manual" class="d-inline-block" #dropdown="ngbDropdown">
                                    <button type="button" class="btn btn-outline-secondary" id="dropdownForm1"
                                        ngbDropdownToggle>
                                        <i class="bx bx-filter"></i> Filter
                                    </button>
                                    <div ngbDropdownMenu aria-labelledby="dropdownForm1">
                                        <div class="p-3">
                                            <div class="mb-2">
                                                <label><i class="bx bx-filter mr-1"></i>Date Filter</label>
                                                <ng-select class="ng-filter" [clearable]="false" [searchable]="false"
                                                    [(ngModel)]="selectedFilter">
                                                    <ng-option *ngFor="let f of filters" [value]="f">{{ f }}</ng-option>
                                                </ng-select>
                                            </div>

                                            <ng-container *ngIf="selectedFilter==='Custom'">
                                                <div class="mb-2">
                                                    <label><i class="bx bx-calendar mr-1"></i>From Date</label>
                                                    <input type="date" [(ngModel)]="fromDate" class="form-control">
                                                </div>
                                                <div class="mb-2">
                                                    <label><i class="bx bx-calendar mr-1"></i>To Date</label>
                                                    <input type="date" [(ngModel)]="toDate" class="form-control">
                                                </div>
                                            </ng-container>

                                            <div class="mb-2">
                                                <label><i class="bx bx-filter mr-1"></i>Project</label>
                                                <ng-select placeholder="Choose..." [(ngModel)]="projectId"
                                                    class="ng-filter" [clearable]="false" [searchable]="false">
                                                    <ng-option *ngFor="let project of projects" [value]="project.id">
                                                        {{ project.name }}
                                                    </ng-option>
                                                </ng-select>
                                            </div>

                                            <div class="mb-2">
                                                <label><i class="bx bx-list-check mr-1"></i>Status</label>
                                                <ng-select placeholder="Select Status" [(ngModel)]="selectedStatus"
                                                    class="ng-filter" [clearable]="false" [searchable]="false">
                                                    <ng-option *ngFor="let status of statuses" [value]="status">{{
                                                        status }}</ng-option>
                                                </ng-select>
                                            </div>

                                            <div class="mb-2">
                                                <label><i class="bx bx-up-arrow-circle mr-1"></i>Priority</label>
                                                <ng-select placeholder="Select Priority" [(ngModel)]="selectedPriority"
                                                    class="ng-filter" [clearable]="false" [searchable]="false">
                                                    <ng-option *ngFor="let priority of priorities" [value]="priority">{{
                                                        priority }}</ng-option>
                                                </ng-select>
                                            </div>

                                            <button type="button"
                                                (click)="filterAndFetchMilestone(selectedFilter, projectId, dropdown)"
                                                class="btn btn-secondary w-100">
                                                Search
                                            </button>
                                        </div>
                                        <div class="dropdown-divider"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-auto ms-auto">
                                <button type="button" class="btn btn-secondary" (click)="upsertMilestone()"
                                    [ngClass]="{'not-allowed':!privilege.canEdit}"
                                    [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): milestone.edit' : ''">
                                    <i class="bx bx-plus"></i> Add Milestone
                                </button>
                            </div>
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="200">Title</th>
                                    <th scope="col" width="200">Start Date</th>
                                    <th scope="col" width="200">Deadline</th>
                                    <th scope="col" width="200">Status</th>
                                    <th scope="col" width="200">Priority</th>
                                    <th scope="col" width="200" class="text-center">Estimated Hours</th>
                                    <th scope="col" width="200" class="text-center">Actual Hours</th>
                                    <th scope="col" width="160" class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let milestone of tableData.content | search : 'title' : searchKeyword; let i = index">
                                    <td>{{ i + 1 }}.</td>
                                    <td>{{ milestone.title }}</td>
                                    <td>{{ milestone.startDate | date:'MMM dd, yyyy' }}</td>
                                    <td>{{ milestone.deadline | date:'MMM dd, yyyy' }}</td>
                                    <td>
                                        <span [ngClass]="getBadgeClass(milestone.status)">
                                            {{ formatStatus(milestone.status) }}
                                        </span>
                                    </td>
                                    <td>
                                        <span [ngClass]="getPriorityBadgeClass(milestone.priority)">
                                            {{ milestone.priority }}
                                        </span>
                                    </td>

                                    <td class="text-center">{{ milestone.estimatedHours }}</td>
                                    <td class="text-center">{{ milestone.actualHours }}</td>
                                    <td class="actions">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" [id]="i"
                                                [checked]="milestone.disabled"
                                                [ngClass]="{'no-event':milestone?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                                                [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): milestone.edit' : milestone.disabled ? 'Mark ' + milestone.title + ' as enabled.' : 'Mark ' + milestone.title + ' as disabled.'"
                                                placement="top" container="body" [(ngModel)]="milestone.disabled"
                                                (change)="toggleMilestoneStatus(milestone)">
                                            <label class="form-check-label" [for]="i"></label>
                                        </div>
                                        <i class="bx bx-edit alert-primary"
                                            [ngClass]="{'no-event':milestone?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                                            [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): milestone.edit' : 'Update Milestone'"
                                            (click)="upsertMilestone(milestone)"></i>
                                        <i *ngIf="!milestone?.isDeleteInProgress" class="bx bx-trash alert-secondary"
                                            [ngClass]="{'not-allowed':!privilege.canDelete}"
                                            [ngbTooltip]="!privilege.canDelete ? 'You need permissions for this action. Required permission(s): milestone.delete' : 'Delete Milestone'"
                                            (click)="deleteMilestone(milestone, i)"></i>
                                        <div *ngIf="milestone?.isDeleteInProgress" role="status"
                                            class="spinner-border spinner-border-sm text-danger">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="9">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container
                                            *ngIf="tableData.content && tableData.content.length < 1; else noSearchResults">
                                            <td colspan="9">No milestones were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="9"
                                                *ngIf="searchKeyword && (tableData.content | search : 'title' : searchKeyword).length == 0">
                                                No milestones were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row justify-content-between align-items-center pt-3">
                            <div class="col-lg-auto">
                              <div class="pagination-entries" id="tickets-table_length">
                                <label class="d-flex align-items-center m-0">
                                  <span>Items per page</span>
                                  <select name="tickets-table_length" aria-controls="tickets-table" [(ngModel)]="tableData.size"
                                    (change)="loadTableData(null)"
                                    class="custom-select custom-select-sm form-control form-control-sm mx-2">
                                    <option *ngFor="let page of pageSizes" [value]="page">{{page}}</option>
                                  </select>
                                </label>
                              </div>
                            </div>
                            <div *ngIf="tableData?.content?.length > 0" class="col-lg-auto">
                              <ngb-pagination [collectionSize]="tableData.totalElements" [(page)]="tableData.number"
                                [pageSize]="tableData.size" (pageChange)="onPageChange($event)">
                              </ngb-pagination>
                            </div>
                          </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>